var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sign-page',{attrs:{"title-text":"转正预警","request":_vm.request,"title-menus":[],"column-list":_vm.columnList,"table-actions":[],"table-size":"large","need-data-file":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }